import React, { useEffect, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import Swal from "sweetalert2";
import { studyEventFormSchemaServices } from "../../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../../APIServices/studyEventManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const SpecialEventForAssignForm = ({ tableRef, onMouseDown, metadata }) => {
  const [version, setVersion] = useState("");
  const [schemaId, setSchemaId] = useState("");
  const [eventSchema, setEventSchema] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSchemaIds, setSelectedSchemaIds] = useState([]);
  let { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false)

  const getEventFormSchema = async (e) => {
    setLoading(true);
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setEventSchema(data?.data || []);
    setLoading(false);
  };

  const findSpecialEventForm = async (e) => {
    let data = await studyEventManagementServices.findSpecialEventForm(
      studyId,
      metadata?.formId,
      version
    );
    setSelectedSchemaIds(
      (data?.data || [])?.map((item) => ({
        schemaId: item.schemaId,
        version: item.formVersion,
      }))
    );
  };

  useEffect(() => {
    if (studyId && version) {
      findSpecialEventForm();
    }
  }, [studyId, schemaId, version]);

  const addUpdateStudySpecialEventSchema = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Assign/Re-Assign/Unassign Study Event Schema!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.studyId = studyId;
        userData.schemaIds = selectedSchemaIds?.map((item) => item.schemaId);
        userData.formId = metadata?.formId;
        userData.version = String(version);
        userData.formName = metadata?.formName;
        let data =
          await studyEventManagementServices.addUpdateStudySpecialEventSchema(
            userData
          );
        if (data?.statusCode === 200) {
          findSpecialEventForm();
        }
        setButtonLoader(false)
      }
    });
  };

  let checkFormVersion =
    selectedSchemaIds?.length > 0
      ? selectedSchemaIds?.some(
          (item) => Number(item.version) === Number(version)
        )
      : true;

  useEffect(() => {
    setVersion("");
    setSchemaId("");
    setSelectedSchemaIds([]);
  }, [metadata]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = eventSchema.map((item) => ({
        schemaId: item.schemaId,
        version: version,
      }));
      setSelectedSchemaIds(allIds);
    } else {
      setSelectedSchemaIds([]);
    }
  };

  const handleSingleSelect = (schemaId) => {
    setSelectedSchemaIds((prevSelected) => {
      const exists = prevSelected.some((item) => item.schemaId === schemaId);

      if (exists) {
        return prevSelected.filter((item) => !(item.schemaId === schemaId));
      } else {
        return [...prevSelected, { schemaId, version }];
      }
    });
  };

  const isAllSelected =
    eventSchema?.length > 0 &&
    selectedSchemaIds?.length === eventSchema?.length;

  useEffect(() => {
    getEventFormSchema();
  }, []);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"15%"}
        style={{ height: "-webkit-fill-available" }}
      >
        <Table ref={tableRef} className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>Form Version</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: metadata?.version || 1 }, (_, i) => i + 1)
              ?.reverse()
              ?.map((versionNumber, index) => (
                <tr
                  onClick={() => setVersion(versionNumber)}
                  key={index}
                  className={`CP ${
                    version === versionNumber ? "highlighted" : ""
                  }`}
                >
                  <td>Version {versionNumber}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {version && (
          <>
            <div className="d-flex justify-content-between p-2 position-sticky top-0 z-1">
              <Form.Select
                onChange={(e) => setSchemaId(e.target.value)}
                style={{ fontSize: 12, width: 200 }}
                className="br3"
                disabled={eventSchema?.length === 0}
              >
                {eventSchema?.length > 0 ? (
                  eventSchema?.map((item, index) => (
                    <option
                      selected={schemaId === item?.schemaId}
                      key={index}
                      value={item?.schemaId}
                    >
                      {item?.schemaName}
                    </option>
                  ))
                ) : (
                  <option value={""}>No Schema</option>
                )}
              </Form.Select>
              <div>
                <button
                  disabled={!version || buttonLoader}
                  onClick={addUpdateStudySpecialEventSchema}
                  className="updateProfile"
                >
                  {buttonLoader ? (
                    <div className="hstack gap-2">
                      <Spinner size="sm"/> Assiging...
                    </div>
                  ) : (
                    "Assign Now"
                  )}
                </button>
              </div>
            </div>
            {loading ? (
              <PageLoader/>
            ) : eventSchema?.length === 0 ? (
              <NoDataFoundTable MSG={"Event schema not found!"} />
            ) : (
              <>
                <Table
                  ref={tableRef}
                  className="m-0 custom-table"
                  hover
                  striped
                >
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        <Form.Check
                          type="checkbox"
                          disabled={!version || !checkFormVersion}
                          onChange={(e) => handleSelectAll(e)}
                          checked={isAllSelected}
                        />
                      </th>
                      <th>Schema Name</th>
                      <th>Assign Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {eventSchema?.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <Form.Check
                            type="checkbox"
                            disabled={!version || !checkFormVersion}
                            checked={selectedSchemaIds.some(
                              (selected) =>
                                selected.schemaId === item.schemaId &&
                                Number(selected.version) === Number(version)
                            )}
                            onChange={() => handleSingleSelect(item.schemaId)}
                          />
                        </td>
                        <td>{item?.schemaName}</td>
                        <td>{item?.assignDate}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </>
        )}
      </SplitPane>
    </>
  );
};

export default SpecialEventForAssignForm;
